import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickRequestChanges", "approvalType"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { APPROVAL_REQUEST_CHANGES } from '../../constants/trackingConstants';
import { trackInteraction } from '../../utils/usageTracker.ts';
import { jsx as _jsx } from "react/jsx-runtime";
function RequestChangesButton(props) {
  const {
      onClickRequestChanges,
      approvalType
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const onClickRequestChangesButton = () => {
    onClickRequestChanges();
    trackInteraction(APPROVAL_REQUEST_CHANGES, approvalType);
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.noAccessTooltip"
    }),
    disabled: !props.disabled,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      use: "tertiary-light"
    }, buttonProps, {
      onClick: onClickRequestChangesButton,
      disabled: props.disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.RequestChangesButton.text"
      })
    }))
  });
}
export default RequestChangesButton;